import AuthHeading from "components/v2/Auth/AuthHeading";
import useSendPasswordResetLink from "api/UserResource/useSendPasswordResetLink";
import { ButtonLoader } from "components";
import FormField from "components/v2/Auth/AuthField";
import { Form, Formik } from "formik";
import AuthLayout from "layouts/AuthLayout";
import * as Yup from "yup";
import { Message } from "primereact/message";
import { FiX } from "react-icons/fi";
import { useState } from "react";

const SendPasswordResetLink = () => {
	const [successMessage, setsuccessMessage] = useState(true);

	const initialValues = {
		email: "",
	};

	const validate = Yup.object().shape({
		email: Yup.string().required("Email is required"),
	});

	const { mutateAsync, isLoading, isSuccess } = useSendPasswordResetLink();
	const handleSubmit = async (data) => {
		await mutateAsync({
			...data,
		});
	};

	return (
		<AuthLayout>
			<AuthHeading heading="Reset your password" subheading="We'll email you a link to set a new password." />

			<div>
				<Formik
					initialValues={initialValues}
					validationSchema={validate}
					onSubmit={(data) => handleSubmit(data)}
				>
					{() => (
						<Form className="auth-recovery" noValidate>
							{isSuccess && successMessage && (
								<div>
									<Message
										severity="success"
										className="font-sans text-left text-sm rounded-md"
										content={
											<div className="flex items-center gap-2 w-full">
												<span>
													Check your inbox for a password reset link.
												</span>
												<button
													type="button"
													onClick={() => setsuccessMessage(false)}
												>
													<FiX size={20} />
												</button>
											</div>
										}
									/>
								</div>
							)}
							<div>
								<FormField name="email" type="email" label="Email address" placeholder="you@example.com" />
							</div>

							<div>
								<button
									type="submit"
									className="auth-primary"
									disabled={isLoading}
								>
									{isLoading ? (
										<>
											Sending...
											<ButtonLoader
												size={25}
												color="rgba(255, 255, 255)"
											/>{" "}
										</>
									) : (
										"Send reset link"
									)}
								</button>
							</div>
						</Form>
					)}
				</Formik>
			</div>
		</AuthLayout>
	);
};

export default SendPasswordResetLink;
